import React from 'react';
import { useGetProfile } from '../hooks/useProfile.ts';

/* Lets an admin choose which M-Pesa paybill or till collects for something (a welfare plan, a contribution category).
   Only shown when the group has more than one, because with one there is nothing to choose. */
export default function PaybillSelect({ value, onChange, label = 'Collect payments into' }) {
  const { data: profile } = useGetProfile();
  const credentials = (profile?.data?.all_mpesa_credentials || []).filter((c) => c.is_active !== false);
  if (credentials.length < 2) return null;

  return (
    <div>
      <label className="block text-sm font-medium mb-1">{label}</label>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : '')}
        className="w-full border rounded px-3 py-2"
      >
        <option value="">Default (the group's main paybill)</option>
        {credentials.map((c) => (
          <option key={c.id} value={c.id}>
            {(c.account_name || (c.paybill_number ? `Paybill ${c.paybill_number}` : `Till ${c.shortcode}`)) + (c.is_default ? ' (default)' : '')} · {c.paybill_number || c.shortcode}
          </option>
        ))}
      </select>
      <p className="text-xs text-gray-500 mt-1">The M-Pesa prompt and the payment go through this paybill.</p>
    </div>
  );
}
